{
  "labels": {
    "paste": "Ielīmēt",
    "pasteAsPlaintext": "Ielīmēt kā vienkāršu tekstu",
    "pasteCharts": "Ielīmēt grafikus",
    "selectAll": "Atlasīt visu",
    "multiSelect": "Pievienot elementu atlasei",
    "moveCanvas": "Pārvietot tāfeli",
    "cut": "Izgriezt",
    "copy": "Kopēt",
    "copyAsPng": "Kopēt starpliktuvē kā PNG",
    "copyAsSvg": "Kopēt starpliktuvē kā SVG",
    "copyText": "Kopēt starpliktuvē kā tekstu",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Pārvietot vienu slāni augstāk",
    "sendToBack": "Pārvietot uz zemāko slāni",
    "bringToFront": "Pārvietot uz virsējo slāni",
    "sendBackward": "Pārvietot par vienu slāni zemāk",
    "delete": "Dzēst",
    "copyStyles": "Kopēt stilus",
    "pasteStyles": "Ielīmēt stilus",
    "stroke": "Svītras krāsa",
    "changeStroke": "",
    "background": "Fona krāsa",
    "changeBackground": "",
    "fill": "Aizpildījums",
    "strokeWidth": "Svītras platums",
    "strokeStyle": "Svītras stils",
    "strokeStyle_solid": "Vienlaidu",
    "strokeStyle_dashed": "Raustīta līnija",
    "strokeStyle_dotted": "Punktota līnija",
    "sloppiness": "Precizitāte",
    "opacity": "Necaurspīdīgums",
    "textAlign": "Teksta līdzināšana",
    "edges": "Malas",
    "sharp": "Asas",
    "round": "Apaļas",
    "arrowheads": "Bultas",
    "arrowhead_none": "Nekādas",
    "arrowhead_arrow": "Bulta",
    "arrowhead_bar": "Svītra",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Trijstūris",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Teksta lielums",
    "fontFamily": "Fontu saime",
    "addWatermark": "Pievienot \"Radīts ar Excalidraw\"",
    "handDrawn": "Rokraksts",
    "normal": "Parasts",
    "code": "Kods",
    "small": "Mazs",
    "medium": "Vidējs",
    "large": "Liels",
    "veryLarge": "Ļoti liels",
    "solid": "Pilns",
    "hachure": "Svītrots",
    "zigzag": "Zigzaglīnija",
    "crossHatch": "Šķērssvītrots",
    "thin": "Šaurs",
    "bold": "Trekns",
    "left": "Pa kreisi",
    "center": "Vidū",
    "right": "Pa labi",
    "extraBold": "Īpaši trekns",
    "architect": "Arhitekts",
    "artist": "Mākslinieks",
    "cartoonist": "Karikatūrists",
    "fileTitle": "Datnes nosaukums",
    "colorPicker": "Krāsu atlasītājs",
    "canvasColors": "Izmantots tāfelei",
    "canvasBackground": "Ainas fons",
    "drawingCanvas": "Tāfele",
    "clearCanvas": "",
    "layers": "Slāņi",
    "actions": "Darbības",
    "language": "Valoda",
    "liveCollaboration": "Sadarbība tiešsaistē...",
    "duplicateSelection": "Izveidot kopiju",
    "untitled": "Bez nosaukuma",
    "name": "Vārds",
    "yourName": "Jūsu vārds",
    "madeWithExcalidraw": "Radīts ar Excalidraw",
    "group": "Grupēt atlasīto",
    "ungroup": "Atgrupēt atlasīto",
    "collaborators": "Dalībnieki",
    "toggleGrid": "",
    "addToLibrary": "Pievienot bibliotēkai",
    "removeFromLibrary": "Izņemt no bibliotēkas",
    "libraryLoadingMessage": "Ielādē bibliotēku…",
    "libraries": "Apskatīt bibliotēkas",
    "loadingScene": "Ielādē ainu…",
    "loadScene": "",
    "align": "Līdzināt",
    "alignTop": "Līdzināt augšpusē",
    "alignBottom": "Līdzināt lejā",
    "alignLeft": "Līdzināt pa kreisi",
    "alignRight": "Līdzināt pa labi",
    "centerVertically": "Centrēt vertikāli",
    "centerHorizontally": "Centrēt horizontāli",
    "distributeHorizontally": "Izdalīt horizontāli",
    "distributeVertically": "Izdalīt vertikāli",
    "flipHorizontal": "Apmest horizontāli",
    "flipVertical": "Apmest vertikāli",
    "viewMode": "Skata režīms",
    "share": "Kopīgot",
    "showStroke": "Rādīt svītras krāsas atlasītāju",
    "showBackground": "Rādīt fona krāsas atlasītāju",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "Personīgā bibliotēka",
    "excalidrawLib": "Excalidraw bibliotēka",
    "decreaseFontSize": "Samazināt fonta izmēru",
    "increaseFontSize": "Palielināt fonta izmēru",
    "unbindText": "Atdalīt tekstu",
    "bindText": "Piesaistīt tekstu figūrai",
    "createContainerFromText": "Ietilpināt tekstu figurā",
    "link": {
      "edit": "Rediģēt saiti",
      "editEmbed": "",
      "create": "",
      "label": "Saite",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Rediģēt līniju",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Fiksēt",
      "unlock": "Atbrīvot",
      "lockAll": "Fiksēt visu",
      "unlockAll": "Atbrīvot visu"
    },
    "statusPublished": "Publicēts",
    "sidebarLock": "Paturēt atvērtu sānjoslu",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "Neviena vienība vēl nav pievienota...",
    "hint_emptyLibrary": "Atlasiet objektu tāfelē, lai to šeit pievienotu, vai pievienojiet publisku bibliotēku zemāk.",
    "hint_emptyPrivateLibrary": "Atlasiet objektu tāfelē, lai to šeit pievienotu.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Atiestatīt tāfeli",
    "exportJSON": "Eksportēt kā failu",
    "exportImage": "Eksportēt attēlu...",
    "export": "Saglabāt uz...",
    "copyToClipboard": "Kopēt starpliktuvē",
    "copyLink": "",
    "save": "Saglabāt pašreizējo datni",
    "saveAs": "Saglabāt kā",
    "load": "Atvērt",
    "getShareableLink": "Iegūt kopīgošanas saiti",
    "close": "Aizvērt",
    "selectLanguage": "Izvēlieties valodu",
    "scrollBackToContent": "Atgriezties pie satura",
    "zoomIn": "Tuvināt",
    "zoomOut": "Tālināt",
    "resetZoom": "Atiestatīt tuvinājumu",
    "menu": "Izvēlne",
    "done": "Gatavs",
    "edit": "Rediģēt",
    "undo": "Atsaukt",
    "redo": "Atcelt atsaukšanu",
    "resetLibrary": "Atiestatīt bibliotēku",
    "createNewRoom": "Izveidot jaunu telpu",
    "fullScreen": "Pilnekrāna režīms",
    "darkMode": "Tumšais režīms",
    "lightMode": "Gaišais režīms",
    "systemMode": "",
    "zenMode": "Zen režīms",
    "objectsSnapMode": "",
    "exitZenMode": "Pamest Zen režīmu",
    "cancel": "Atcelt",
    "saveLibNames": "",
    "clear": "Notīrīt",
    "remove": "Noņemt",
    "embed": "",
    "publishLibrary": "",
    "submit": "Iesniegt",
    "confirm": "Apstiprināt",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Šī funkcija notīrīs visu tāfeli. Vai turpināt?",
    "couldNotCreateShareableLink": "Nevarēja izveidot kopīgojamo saiti.",
    "couldNotCreateShareableLinkTooBig": "Nevarēja izveidot kopīgojamo saiti – aina ir par lielu",
    "couldNotLoadInvalidFile": "Nevarēja ielādēt nederīgu datni",
    "importBackendFailed": "Ielāde no krātuves neizdevās.",
    "cannotExportEmptyCanvas": "Nevar eksportēt tukšu tāfeli.",
    "couldNotCopyToClipboard": "Nevarēja nokopēt starpliktuvē.",
    "decryptFailed": "Nevarēja atšifrēt datus.",
    "uploadedSecurly": "Augšuplāde nodrošināta ar šifrēšanu no gala līdz galam, kas nozīmē, ka Excalidraw serveri un trešās puses nevar lasīt saturu.",
    "loadSceneOverridePrompt": "Ārēja satura ielāde aizstās jūsu pašreizējo saturu. Vai vēlaties turpināt?",
    "collabStopOverridePrompt": "Sesijas pārtraukšana pārrakstīs jūsu iepriekšējo zīmējumu, kas saglabāts jūsu pārlūkā. Vai turpināt?\n\n(Ja vēlaties paturēt zīmējumu, kas saglabāts jūsu pārlūkā, vienkārši aizveriet pārlūka cilni.)",
    "errorAddingToLibrary": "Nevarēja pievienot vienumu bibliotēkai",
    "errorRemovingFromLibrary": "Nevarēja izņemt vienumu no bibliotēkas",
    "confirmAddLibrary": "Šī funkcija pievienos {{numShapes}} formu(-as) jūsu bibliotēkai. Vai turpināt?",
    "imageDoesNotContainScene": "Šķiet, ka attēls nesatur ainas datus. Vai iespējojāt ainas iegulšanu, kad eksportējāt?",
    "cannotRestoreFromImage": "Ainu nevarēja atgūt no attēla datnes",
    "invalidSceneUrl": "Nevarēja importēt ainu no norādītā URL. Vai nu tas ir nederīgs, vai nesatur derīgus Excalidraw JSON datus.",
    "resetLibrary": "Šī funkcija iztukšos bibliotēku. Vai turpināt?",
    "removeItemsFromsLibrary": "Vai izņemt {{count}} vienumu(s) no bibliotēkas?",
    "invalidEncryptionKey": "Šifrēšanas atslēgai jābūt 22 simbolus garai. Tiešsaistes sadarbība ir izslēgta.",
    "collabOfflineWarning": "Nav pieejams interneta pieslēgums.\nJūsu izmaiņas netiks saglabātas!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Neatbalstīts datnes veids.",
    "imageInsertError": "Nevarēja ievietot attēlu. Mēģiniet vēlāk...",
    "fileTooBig": "Datne ir par lielu. Lielākais atļautais izmērs ir {{maxSize}}.",
    "svgImageInsertError": "Nevarēja ievietot SVG attēlu. Šķiet, ka SVG marķējums nav derīgs.",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "Nevarēja savienoties ar sadarbošanās serveri. Lūdzu, pārlādējiet lapu un mēģiniet vēlreiz.",
    "importLibraryError": "Nevarēja ielādēt bibliotēku",
    "saveLibraryError": "",
    "collabSaveFailed": "Darbs nav saglabāts datubāzē. Ja problēma turpinās, saglabājiet datni lokālajā krātuvē, lai nodrošinātos pret darba pazaudēšanu.",
    "collabSaveFailed_sizeExceeded": "Darbs nav saglabāts datubāzē, šķiet, ka tāfele ir pārāk liela. Saglabājiet datni lokālajā krātuvē, lai nodrošinātos pret darba pazaudēšanu.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Atlase",
    "lasso": "",
    "image": "Ievietot attēlu",
    "rectangle": "Taisnstūris",
    "diamond": "Rombs",
    "ellipse": "Elipse",
    "arrow": "Bulta",
    "line": "Līnija",
    "freedraw": "Zīmēt",
    "text": "Teksts",
    "library": "Bibliotēka",
    "lock": "Paturēt izvēlēto rīku pēc darbības",
    "penMode": "Pildspalvas režīms – novērst pieskaršanos",
    "link": "",
    "eraser": "Dzēšgumija",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "Roka (panoramēšanas rīks)",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Tāfeles darbības",
    "selectedShapeActions": "Izvēlētās formas darbības",
    "shapes": "Formas"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Klikšķiniet, lai sāktu zīmēt vairākus punktus; velciet, lai zīmētu līniju",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Spiediet un velciet; atlaidiet, kad pabeidzat",
    "text": "Ieteikums: lai pievienotu tekstu, varat arī jebkur dubultklikšķināt ar atlases rīku",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Publicēt savu bibliotēku",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Šis iestatījums var tikt ieslēgts ar \"dom.events.asyncClipboard.clipboardItem\" marķieri pārslēgtu uz \"true\". Lai mainītu pārlūka marķierus Firefox, apmeklē \"about:config\" lapu.",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Nevar rādīt priekšskatījumu",
    "canvasTooBig": "Iespējams, tāfele ir par lielu.",
    "canvasTooBigTip": "Ieteikums: mēģiniet satuvināt pašus tālākos elementus."
  },
  "errorSplash": {
    "headingMain": "Notikusi kļūda. Mēģiniet <button>pārlādēt lapu.</button>",
    "clearCanvasMessage": "Ja pārlādēšana nestrādā, mēģiniet <button>notīrot tāfeli.</button>",
    "clearCanvasCaveat": " Tas novedīs pie darba zaudēšanas ",
    "trackedToSentry": "Kļūda ar kodu {{eventId}} tika noteikta mūsu sistēmā.",
    "openIssueMessage": "Mēs uzmanījāmies, lai neiekļautu jūsu ainas informāciju šajā kļūdā. Ja jūsu aina nav privāta, lūdzu ziņojiet par šo kļūdu mūsu <button>kļūdu uzskaitē.</button> Lūdzu, miniet sekojošo informāciju to kopējot un ielīmējot jūsu ziņojumā platformā GitHub.",
    "sceneContent": "Ainas saturs:"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Sākt sesiju",
    "button_stopSession": "Beigt sesiju",
    "desc_inProgressIntro": "Notiek tiešsaistes sadarbības sesija.",
    "desc_shareLink": "Dalieties ar šo saiti ar jebkuru, ar ko vēlaties sadarboties:",
    "desc_exitSession": "Sesijas beigšana jūs atvienos no sadarbošanās, bet jūs vēl joprojām varēsiet strādāt ar ainu savā datorā. Ievērojiet, ka šis neietekmēs citus dalībniekus, un viņi vēl joprojām varēs sadarboties savā ainas versijā.",
    "shareTitle": "Pievienoties tiešsaistes sadarbībai programmā Excalidraw"
  },
  "errorDialog": {
    "title": "Kļūda"
  },
  "exportDialog": {
    "disk_title": "Saglabāt diskā",
    "disk_details": "Eksportēt ainas datus datnē, ko vēlāk varēsiet importēt.",
    "disk_button": "Saglabāt datnē",
    "link_title": "Kopīgošanas saite",
    "link_details": "Eksportēt kā tikai lasāmu saiti.",
    "link_button": "Eksportēt kā saiti",
    "excalidrawplus_description": "Saglabāt ainu savā Excalidraw+ darbvietā.",
    "excalidrawplus_button": "Eksportēt",
    "excalidrawplus_exportError": "Pašreiz nevarēja eksportēt uz Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Lasīt mūsu blogu",
    "click": "klikšķis",
    "deepSelect": "Atlasīt dziļumā",
    "deepBoxSelect": "Atlasīt dziļumā kastes ietvaros, un nepieļaut pavilkšanu",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Liekta bulta",
    "curvedLine": "Liekta līnija",
    "documentation": "Dokumentācija",
    "doubleClick": "dubultklikšķis",
    "drag": "vilkt",
    "editor": "Redaktors",
    "editLineArrowPoints": "Rediģēt līniju/bultu punktus",
    "editText": "Rediģēt tekstu/pievienot birku",
    "github": "Sastapāt kļūdu? Ziņot",
    "howto": "Sekojiet mūsu instrukcijām",
    "or": "vai",
    "preventBinding": "Novērst bultu piesaistīšanos",
    "tools": "Rīki",
    "shortcuts": "Tastatūras saīsnes",
    "textFinish": "Pabeigt rediģēšanu (teksta redaktorā)",
    "textNewLine": "Nākamā rindiņa (teksta redaktorā)",
    "title": "Palīdzība",
    "view": "Skatīt",
    "zoomToFit": "Iestatīt mērogu, kas iekļauj visus elementus",
    "zoomToSelection": "Iestatīt mērogu, lai rādītu atlasi",
    "toggleElementLock": "Fiksēt/atbrīvot atlasīto",
    "movePageUpDown": "Pārvietot lapu augšup/lejup",
    "movePageLeftRight": "Pārvietot lapu pa labi/kreisi",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Notīrīt tāfeli"
  },
  "publishDialog": {
    "title": "Publicēt bibliotēku",
    "itemName": "Vienuma nosaukums",
    "authorName": "Autora vārds",
    "githubUsername": "GitHub lietotājvārds",
    "twitterUsername": "Twitter lietotājvārds",
    "libraryName": "Bibliotēkas nosaukums",
    "libraryDesc": "Bibliotēkas apraksts",
    "website": "Mājaslapa",
    "placeholder": {
      "authorName": "Jūsu vārds vai lietotājvārds",
      "libraryName": "Jūsu bibliotēkas nosaukums",
      "libraryDesc": "Bibliotēkas apraksts, kas palīdzēs citiem saprast tās pielietojumu",
      "githubHandle": "GitHub lietotājvārds (neobligāts), lai jūs varētu rediģēt bibliotēku pēc tās iesniegšanas izskatīšanai",
      "twitterHandle": "Twitter lietotājvārds (neobligāts), lai mēs varētu jūs pieminēt kā autoru, kad reklamēsim bibliotēku platformā Twitter",
      "website": "Saikne uz jūsu personīgo mājaslapu vai kādu citu lapu (neobligāta)"
    },
    "errors": {
      "required": "Obligāts",
      "website": "Ievadiet derīgu URL"
    },
    "noteDescription": "Iesniegt savu bibliotēku iekļaušanai <link>publiskajā bibliotēku datubāzē</link>, lai citi to varētu izmantot savos zīmējumos.",
    "noteGuidelines": "Šai bibliotēkai vispirms jātiek manuāli apstiprinātai. Lūdzu, izlasiet <link>norādījumus</link> pirms iesniegšanas. Jums vajadzēs GitHub kontu, lai sazinātos un veiktu izmaiņas, ja tādas būs pieprasītas, bet tas nav absolūti nepieciešams.",
    "noteLicense": "Iesniedzot bibliotēku, jūs piekrītat tās publicēšanai saskaņā ar <link>MIT Licenci, </link>kas īsumā nozīmē, ka jebkurš to varēs izmantot bez ierobežojumiem.",
    "noteItems": "Katram bibliotēkas vienumam jābūt savam nosaukumam, lai to varētu atrast filtrējot. Tiks iekļauti sekojošie bibliotēkas vienumi:",
    "atleastOneLibItem": "Lūdzu, atlasiet vismaz vienu bibliotēkas vienumu, lai sāktu darbu",
    "republishWarning": "Ievēro: daži no atzīmētajiem objektiem jau atzīmēti kā publicēti vai iesniegti publicēšanai. Tos vajadzētu atkārtoti iesniegt tikai tad, ja vēlies labot esošo bibliotēku."
  },
  "publishSuccessDialog": {
    "title": "Bibliotēka iesniegta",
    "content": "Paldies, {{authorName}}! Jūsu bibliotēka iesniegta izskatīšanai. Jūs varat izsekot iesnieguma statusam<link>šeit</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Atiestatīt bibliotēku",
    "removeItemsFromLib": "Noņemt atlasītos vienumus no bibliotēkas"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Jūsu zīmējumi ir šifrēti no gala līdz galam; līdz ar to Excalidraw serveri tos nekad neredzēs.",
    "link": "Ieraksts par šifrēšanu no gala līdz galam Excalidraw blogā"
  },
  "stats": {
    "angle": "Leņķis",
    "shapes": "",
    "height": "Augstums",
    "scene": "Aina",
    "selected": "Atlasīti",
    "storage": "Krātuve",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "Kopā",
    "version": "Versija",
    "versionCopy": "Klikšķiniet, lai nokopētu",
    "versionNotAvailable": "Versija nav pieejama",
    "width": "Platums"
  },
  "toast": {
    "addedToLibrary": "Pievienots bibliotēkai",
    "copyStyles": "Nokopēja stilus.",
    "copyToClipboard": "Nokopēja starpliktuvē.",
    "copyToClipboardAsPng": "Nokopēja {{exportSelection}} starpliktuvē kā PNG ({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Datne saglabāta.",
    "fileSavedToFilename": "Saglabāts kā {filename}",
    "canvas": "tāfeli",
    "selection": "atlasi",
    "pasteAsSingleElement": "Izmantojiet {{shortcut}}, lai ielīmētu kā jaunu elementu, vai ielīmētu esošā teksta lauciņā",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Caurspīdīgs",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Vai tā vietā vēlies doties uz Excalidraw+?",
      "menuHint": "Eksportēšana, iestatījumi, valodas..."
    },
    "defaults": {
      "menuHint": "Eksportēšana, iestatījumi un vēl...",
      "center_heading": "Diagrammas. Izveidotas. Vienkārši.",
      "toolbarHint": "Izvēlies rīku un sāc zīmēt!",
      "helpHint": "Īsceļi un palīdzība"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
